import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ComposableMap } from 'react-simple-maps';

/**
 * **Access:**
 * ```js
 * import { WorldMap } from '@iss/client-react-components';
 * ```
 * A wrapper component for map.
 * Contains information about the projection.
 */
export default class WorldMap extends Component {
  static propTypes = {
    /** Projection type for rendering map. Different types of projections are Albers projection,
     * Azimuthal Equla Area projection, Orthographic projection, etc
     * @see https://www.react-simple-maps.io/docs/composable-map/ for more info */
    projection: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

    /** Projection Config for map. It can be used to render map area with rotate/zoom level. Useful in case of markers. */
    projectionConfig: PropTypes.shape({
      /** rotation level for map */
      rotate: PropTypes.arrayOf(PropTypes.number),
      /** zoom level for rendering map */
      scale: PropTypes.number,
    }),
  };

  static defaultProps = {
    projection: 'geoEqualEarth',
    projectionConfig: {},
  };

  render() {
    const { projection, projectionConfig, ...mapProps } = this.props;

    return <ComposableMap projection={projection} projectionConfig={projectionConfig} {...mapProps} />;
  }
}
